export const mockZipCodes = [
  {
    zipCode: "00605",
    city: "AGUADILLA",
    state: "PR",
    stateName: "Puerto Rico",
  },
  { zipCode: "86510", city: "HOLBROOK", state: "AZ", stateName: "Arizona" },
  { zipCode: "86511", city: "HOLBROOK", state: "AZ", stateName: "Arizona" },
  { zipCode: "86512", city: "KEAMS CANYON", state: "AZ", stateName: "Arizona" },
  { zipCode: "86515", city: "LEUPP", state: "AZ", stateName: "Arizona" },
  {
    zipCode: "90210",
    city: "BEVERLY HILLS",
    state: "CA",
    stateName: "California",
  },
  { zipCode: "12345", city: "SCHENECTADY", state: "NY", stateName: "New York" },
] as const;

export const mockZipCodeTypes = [
  { id: 1, typeName: "Single" },
  { id: 2, typeName: "Range" },
] as const;

export const mockRateStructures = [
  { id: 1, typeName: "Flat Rate" },
  { id: 2, typeName: "Rate per 100lbs" },
  { id: 3, typeName: "Surcharge" },
] as const;

export const mockScopes = [
  { id: 1, typeName: "Both" },
  { id: 2, typeName: "Interstate" },
  { id: 3, typeName: "Intrastate" },
] as const;

export const mockAppliesTo = [
  { id: 1, typeName: "Both" },
  { id: 2, typeName: "Pickup" },
  { id: 3, typeName: "Delivery" },
] as const;

/** API-format detail used by the MSW mock handler for GET /high-cost-zip-schedules/:id */
export const mockHighCostZipCodeScheduleApiDetail = {
  highCostZips: [
    {
      id: 1,
      zipCodeType: 1,
      zipCodeTypeName: "Single",
      lowZipCode: "86510",
      highZipCode: null,
      rateType: 1,
      rateTypeName: "Flat Rate",
      sequenceId: 1,
      rate: "60.00",
      minimumAmt: null,
      scope: "Both",
      appliesTo: "Both",
      state: "AZ",
      stateName: "Arizona",
    },
    {
      id: 2,
      zipCodeType: 2,
      zipCodeTypeName: "Range",
      lowZipCode: "86510",
      highZipCode: "86515",
      rateType: 2,
      rateTypeName: "Rate per 100lbs",
      sequenceId: 2,
      rate: "60.00",
      minimumAmt: "40.00",
      scope: "Interstate",
      appliesTo: "Pickup",
      state: "AZ",
      stateName: "Arizona",
    },
    {
      id: 3,
      zipCodeType: 1,
      zipCodeTypeName: "Single",
      lowZipCode: "86510",
      highZipCode: null,
      rateType: 3,
      rateTypeName: "Surcharge",
      sequenceId: 3,
      rate: "60.00",
      minimumAmt: null,
      scope: "Intrastate",
      appliesTo: "Delivery",
      state: "AZ",
      stateName: "Arizona",
    },
  ],
} as const;
